import {type} from 'arktype';
import {brand, Branded, TypeOf} from 'io-ts';
import {PositiveInt} from './PositiveInt';

interface TransactionIdBrand {
    readonly TransactionId: unique symbol;
}

export const TransactionIdIoTs = brand(
    PositiveInt,
    (n): n is Branded<PositiveInt, TransactionIdBrand> => true,
    'TransactionId'
);

export const TransactionIdArkType = type('number.integer>0').as<TransactionId>();

export type TransactionId = TypeOf<typeof TransactionIdIoTs>;
